export default {"src":"/_next/static/media/whats-app.1a0a4979.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};